import { render } from "./CoursesCaruselSkeleton.vue?vue&type=template&id=83e446f6"
const script = {}

import exportComponent from "/var/www/coursat-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__